import { __decorate } from 'tslib';
import { ElementRef, Renderer2, Input, Directive, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class Blink {
    constructor() {
        this.keyframes = [
            { transform: 'scale(1)' },
            { transform: 'scale(0.93)' },
            { transform: 'scale(0.95)' },
            { transform: 'scale(0.91)' },
            { transform: 'scale(1)' }
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Bounce {
    constructor() {
        this.keyframes = [
            { transform: 'translate(0, 0)' },
            { transform: 'translate(0, 3px)' },
            { transform: 'translate(0, -6px)' },
            { transform: 'translate(0, 3px)' },
            { transform: 'translate(0, 0)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

const defaultDuration = 2000;

class Fade {
    constructor() {
        this.keyframes = [
            { opacity: '1' },
            { opacity: '0.6' },
            { opacity: '0.8' },
            { opacity: '1' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Flicker {
    constructor() {
        this.keyframes = [
            { transform: 'skewX(0deg)' },
            { transform: 'skewX(10deg)' },
            { transform: 'skewX(-10deg)' },
            { transform: 'skewX(5deg)' },
            { transform: 'skewX(-5deg)' },
            { transform: 'skewX(0deg)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Groove {
    constructor() {
        this.keyframes = [
            { transform: 'skewY(0deg) rotate(0deg)' },
            { transform: 'skewY(-10deg) rotateZ(8deg)' },
            { transform: 'skewY(10deg) rotateZ(-8deg)' },
            { transform: 'skewY(6deg) rotateZ(4deg)' },
            { transform: 'skewY(0deg) rotate(0deg)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Jelly {
    constructor() {
        this.keyframes = [
            { transform: 'scaleX(1)' },
            { transform: 'scaleX(0.9)' },
            { transform: 'scaleX(1.25)' },
            { transform: 'scaleX(0.8)' },
            { transform: 'scaleX(1)' }
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Jerk {
    constructor() {
        this.keyframes = [
            { transform: 'translateX(0px) rotateZ(0deg)' },
            { transform: 'translateX(-5px) rotateZ(-15deg)' },
            { transform: 'translateX(5px) rotateZ(15deg)' },
            { transform: 'translateX(-3px) rotateZ(5deg)' },
            { transform: 'translateX(3px) rotateZ(-5deg)' },
            { transform: 'translateX(0px) rotateZ(0deg)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Pop {
    constructor() {
        this.keyframes = [
            { transform: 'scaleX(1) scaleY(1)' },
            { transform: 'scaleX(1.35) scaleY(0.1)' },
            { transform: 'scaleX(0.8) scaleY(1.7)' },
            { transform: 'scaleX(0.6) scaleY(0.85)' },
            { transform: 'scaleX(1) scaleY(1)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Shake {
    constructor() {
        this.keyframes = [
            { transform: 'translateX(0px)' },
            { transform: 'translateX(-3px)' },
            { transform: 'translateX(3px)' },
            { transform: 'translateX(-2px)' },
            { transform: 'translateX(3px)' },
            { transform: 'translateX(-2px)' },
            { transform: 'translateX(0px)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Squeeze {
    constructor() {
        this.keyframes = [
            { transform: 'scaleY(1)' },
            { transform: 'scaleY(0.95)' },
            { transform: 'scaleY(0.9)' },
            { transform: 'scaleY(0.75)' },
            { transform: 'scaleY(1.3)' },
            { transform: 'scaleY(0.95)' },
            { transform: 'scaleY(1)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Swing {
    constructor() {
        this.keyframes = [
            { transform: 'rotateZ(0deg)' },
            { transform: 'rotateZ(15deg)' },
            { transform: 'rotateZ(-15deg)' },
            { transform: 'rotateZ(7deg)' },
            { transform: 'rotateZ(-7deg)' },
            { transform: 'rotateZ(0deg)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

class Tada {
    constructor() {
        this.keyframes = [
            { transform: 'scale(1)' },
            { transform: 'scale(1.1) rotate(3deg)' },
            { transform: 'scale(0.97)' },
            { transform: 'scale(0.99) rotate(-3deg)' },
            { transform: 'scale(1.05)' },
            { transform: 'scale(1)' },
        ];
    }
    start(elementRef, { duration }) {
        elementRef.nativeElement.animate(this.keyframes, { duration });
    }
}

const INTERACTION_TYPES = {
    blink: Blink,
    bounce: Bounce,
    fade: Fade,
    flicker: Flicker,
    groove: Groove,
    jelly: Jelly,
    jerk: Jerk,
    pop: Pop,
    shake: Shake,
    squeeze: Squeeze,
    swing: Swing,
    tada: Tada
};
class NgMicroInteractFactory {
    static setInteraction(type, element, options) {
        return new INTERACTION_TYPES[type]()
            .start(element, Object.assign({ duration: defaultDuration, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)' }, options));
    }
}

let NgMicroInteractDirective = class NgMicroInteractDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.type = 'fade';
        this.trigger = 'mouseover';
    }
    ngAfterViewInit() {
        this.registerEventListeners();
    }
    registerEventListeners() {
        this.renderer.listen(this.el.nativeElement, this.trigger, () => {
            NgMicroInteractFactory.setInteraction(this.type, this.el, this.options);
        });
    }
};
NgMicroInteractDirective.ɵfac = function NgMicroInteractDirective_Factory(t) { return new (t || NgMicroInteractDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgMicroInteractDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgMicroInteractDirective, selectors: [["", "ngMicroInteract", ""]], inputs: { type: "type", trigger: "trigger", options: "options" } });
NgMicroInteractDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    Input()
], NgMicroInteractDirective.prototype, "type", void 0);
__decorate([
    Input()
], NgMicroInteractDirective.prototype, "trigger", void 0);
__decorate([
    Input()
], NgMicroInteractDirective.prototype, "options", void 0);

let NgMicroInteractModule = class NgMicroInteractModule {
};
NgMicroInteractModule.ɵfac = function NgMicroInteractModule_Factory(t) { return new (t || NgMicroInteractModule)(); };
NgMicroInteractModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgMicroInteractModule });
NgMicroInteractModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgMicroInteractDirective, [{
        type: Directive,
        args: [{
                selector: '[ngMicroInteract]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { type: [{
            type: Input
        }], trigger: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgMicroInteractModule, [{
        type: NgModule,
        args: [{
                declarations: [NgMicroInteractDirective],
                imports: [],
                exports: [NgMicroInteractDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgMicroInteractModule, { declarations: [NgMicroInteractDirective], exports: [NgMicroInteractDirective] }); })();

/*
 * Public API Surface of ng-micro-interact
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgMicroInteractDirective, NgMicroInteractModule };

